<template>
  <div>
    <v-card class="mt-2">
      <v-list-item dense>
        <v-list-item-avatar>
          <v-icon x-large :color="this.agendamento.cliente.cor">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ this.agendamento.cliente.nome }}
          </v-list-item-title>
          <v-list-item-content v-if="isRepeteSemanalmente()" class="tipoAgendamento">
            Repete {{ this.tiposAgendamento[this.agendamento.tipo].description }} de
            {{ this.agendamento.dataInicio | date }} até
            {{ this.agendamento.dataFim | date }}.
          </v-list-item-content>
          <v-list-item-content v-else class="tipoAgendamento">
            Agendamento único para {{ this.agendamento.dataInicio | date }}.
          </v-list-item-content>
          <v-list-item-content>
            <div>
              <template v-for="(item, i) in this.agendamento.itens">
                <v-tooltip
                  bottom
                  :key="i"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-chip
                      v-bind="attrs"
                      small
                      outlined
                      color="primary">
                      {{descricaoDiaSemana(item.diaSemana)}}
                      - {{item.horaInicio | time}}
                      - {{item.horaFim | time}}
                    </v-chip>
                  </template>
                </v-tooltip>
              </template>
            </div>
          </v-list-item-content>
        </v-list-item-content>
        <v-list-item-action>
          <tw-agendamento-cadastro @update="onUpdate" :agendamento="this.agendamento">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </tw-agendamento-cadastro>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon small @click="onClickDelete(agendamento)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
    <tw-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import AgendamentoCadastro from '@/modules/agendamento/cadastro/AgendamentoCadastro.vue';
import diasSemana from '@/enums/day-of-week';
import AgendamentoTipo from '@/enums/agendamento-tipo';

export default {
  props: {
    agendamento: Object,
  },
  data() {
    return {
      tiposAgendamento: AgendamentoTipo.keys,
    };
  },
  methods: {
    isRepeteSemanalmente() {
      return this.agendamento.tipo === this.tiposAgendamento.SEMANALMENTE.key;
    },
    descricaoDiaSemana(key) {
      return diasSemana.keys[key].description;
    },
    onUpdate() {
      this.$emit('update');
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este agendamento?',
        `O agendamento ${item.cliente.nome} será removida e esta operação não pode ser desfeita.`,
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
  components: {
    TwAgendamentoCadastro: AgendamentoCadastro,
  },
};
</script>

<style scoped>
.tipoAgendamento{
  font-size: 12px;
}
</style>
